import React from 'react';
import './HelpModal.css';

function HelpModal({ open, onClose }) {
  if (!open) return null;

  return (
    <div className="modal-overlay">
      <div className="help-modal-content">
        <button className="modal-close" onClick={onClose} aria-label="Close">
          <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M0 0h24v24H0z" fill="none"/>
            <path d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7a1 1 0 1 0-1.41 1.41L10.59 12l-4.89 4.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.89a1 1 0 0 0 1.41-1.41L13.41 12l4.89-4.89a1 1 0 0 0 0-1.4z"/>
          </svg>
        </button>
        <h2>How to Play</h2>
        
        <p>Your goal is to crack three hexidecimal codes one level at a time.</p>
        <p>Secret codes follow different rules at each level:</p>
        
        <ul>
          <li>Level 1: Unique digits in <strong>Ascending</strong> order</li>
            <ul>
              <li>Example: 269AB or 058CD</li>
            </ul>
          <li>Level 2: Unique digits in <strong>Ascending or Descending</strong> order</li>
            <ul>
              <li>Example: 269AB or FC851</li>
            </ul>
          <li>Level 3: Digits may repeat, in <strong>Ascending or Descending</strong> order</li>
          <ul>
              <li>Example: 3668D or EEA73</li>
            </ul>
        </ul>

        <p>Your guesses will be highlighted as follows:</p>

        <div className="help-hints">
          <p>🟩 Correct digit in correct position.</p>
          <p>🟨 Correct digit, wrong position.</p>
          <p>⬜ Incorrect, digit not in code.</p>
        </div>

        <p><strong>Hard Mode</strong> requires reusing all revealed hints and allows fewer guesses!</p>

        <h2>Crack all three codes to win, if you run out of guesses on any level the game is over.</h2>

      </div>
    </div>
  );
}

export default HelpModal;
